// extracted by mini-css-extract-plugin
export default {"header":"userExercisesTable_header__mH0pV","noExercises":"userExercisesTable_noExercises__Pokgm","loading":"userExercisesTable_loading__5bV2l"};